import { Dispatch, useEffect, useRef } from 'react'
import { ObservableValue } from '../state/ObservableValue'

export function useObservableEffect<T>(state: ObservableValue<T>, callback: Dispatch<T>) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => state.subscribe((value) => callbackRef.current(value)), [state])
}
